// extracted by mini-css-extract-plugin
module.exports = {"Item":"SocialShare__Item_2fT_F","ItemMax":"SocialShare__ItemMax_3SK5k"};